import script from "./GrTooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./GrTooltip.vue?vue&type=script&setup=true&lang=ts"

import "./GrTooltip.vue?vue&type=style&index=0&id=8182555a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8182555a"]])

export default __exports__